(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_slide"] && !Shopify.designMode) return;
  try {
    const playVisibleSlideVideos = () => {
    document.querySelectorAll('.slide__media-wrapper').forEach((wrapper) => {
      const video = wrapper.querySelector('video');
      if (!video) return;

      const isVisible = getComputedStyle(wrapper).display !== 'none';

      if (isVisible) {
        if (video.paused) video.play().catch(() => {});
      } else if (!video.paused) {
        video.pause();
      }
    });
  };

  playVisibleSlideVideos();
  window.matchMedia('(max-width: 749px)').addEventListener('change', playVisibleSlideVideos);
  } catch(e) { console.error(e); }
})();

})();
